module.exports = __webpack_public_path__ + "static/Rei-b601ecd27c3bd953b7238bdbd08aaa80.webp";